import Spinner from '@atlaskit/spinner';

import React from 'react';

import { styled } from 'styled-components';
import { Dimensions } from 'components/visuals';

const LoadingContainer = styled.td`
  padding-top: ${Dimensions.units(7)}px;
  height: 450px;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const Loading = ({ endUserLicensesTabIsChosen }: { endUserLicensesTabIsChosen: boolean }) => (
  <tr>
    <LoadingContainer colSpan={endUserLicensesTabIsChosen ? 6 : 5}>
      <SpinnerWrapper>
        <Spinner size="large" />
      </SpinnerWrapper>
    </LoadingContainer>
  </tr>
);

export default Loading;
